import { Link } from '@inertiajs/react';
import { MdOutlineDeleteSweep } from 'react-icons/md';
import useCart from '../../store/cart';
import Form from '../Order/Form';
import FlashMessages from '../../components/FlashMessages';

export default function Show() {
  const { cart, increaseQuantity, reduceQuantity, removeItem, clearCart } =
    useCart();

  const totalAmount = cart.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  const extras = {
    total_amount: totalAmount,
    items: cart.map((item) => ({
      product_id: item.id,
      quantity: item.quantity,
      price: item.price,
    })),
  };

  return (
    <div className='max-w-4xl mx-auto p-6'>
      <FlashMessages />
      <h1 className='text-2xl font-bold mt-2 mb-6'>My Cart</h1>

      {cart.length === 0 ? (
        <div className='text-center py-10'>
          <p className='text-gray-600 text-lg'>No items in your cart.</p>
          <Link
            href='/products'
            className='mt-4 inline-block bg-yellow-primary hover:bg-yellow-secondary px-6 py-2 rounded-lg text-black font-semibold shadow'
          >
            Continue Shopping
          </Link>
        </div>
      ) : (
        <div className='grid grid-cols-1 lg:grid-cols-3 gap-6'>
          <div className='lg:col-span-2 space-y-4'>
            {cart.map((item) => (
              <div
                key={item.id}
                className='flex items-center justify-between bg-white shadow rounded-lg p-4'
              >
                <div className='flex items-center gap-4'>
                  <img
                    src={item.image}
                    alt={item.name}
                    className='w-20 h-20 object-cover rounded-lg'
                  />
                  <div>
                    <h2 className='font-semibold text-lg text-gray-600'>
                      {item.name}
                    </h2>
                    <p className='text-gray-600'>₵{item.price}</p>
                  </div>
                </div>

                <div className='flex items-center gap-3'>
                  <button
                    onClick={() => reduceQuantity(item.id)}
                    className='px-2 py-1 bg-gray-500 rounded hover:bg-gray-800 text-xl font-extrabold'
                  >
                    -
                  </button>
                  <span className='font-medium text-gray-800'>
                    {item.quantity}
                  </span>
                  <button
                    onClick={() => increaseQuantity(item.id)}
                    className='px-2 py-1 bg-gray-500 rounded hover:bg-gray-800 text-xl font-extrabold'
                  >
                    +
                  </button>
                  <button
                    onClick={() => removeItem(item.id)}
                    className='ml-4 text-red-500 hover:text-red-700'
                  >
                    <span className='sr-only'>delete</span>
                    <MdOutlineDeleteSweep className='text-3xl' title='Delete' />
                  </button>
                </div>
              </div>
            ))}

            <div className='flex justify-between items-center bg-gray-900 p-4 rounded-lg font-bold text-xl text-white'>
              <span>Total</span>
              <span>₵{totalAmount.toFixed(2)}</span>
            </div>
            <Link
              href='/products'
              className='mt-4 inline-block bg-yellow-primary hover:bg-yellow-secondary px-6 py-2 rounded-lg text-black font-semibold shadow'
            >
              Continue Shopping
            </Link>
          </div>

          <div className='bg-white shadow rounded-lg p-6'>
            <h2 className='text-xl font-bold mb-4 text-gray-600'>
              Complete Your Order
            </h2>
            <Form
              order={{ total_amount: totalAmount }}
              onSubmit={(form) => {
                form.transform((data) => ({
                  ...data,
                  ...extras,
                }));
                form.post('/orders', {
                  onSuccess: () => {
                    clearCart();
                    form.reset();
                  },
                });
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
